import React from 'react'
import { size } from 'lodash'
import {
  ComponentSectionsSectionTechs,
  ProjectBaseFragment,
} from 'Typings/generated-gatsby-types'
import AltPageLayout, {
  AltPageLayoutNavs,
  isFirstSectionHasLabel,
} from 'Components/layout/AltPageLayout'
import DynamicSections, {
  DynamicSectionsDataType,
  getDynamicSectionThemes,
} from 'Components/sections/DynamicSections'
import { HeaderThemeOnScrollChanger } from 'Components/layout/Header'
import ProjectsSlider from 'Components/ProjectsSlider/ProjectsSlider'
import { ApiSeo } from 'Typings/api'
import { FormSection } from 'Components/sections/FormSection'
import { Divider } from 'Components/Divider/Divider'

const getThemes = (sections: DynamicSectionsDataType[], hasProjects: boolean) => {
  const dynamicThemes = getDynamicSectionThemes(sections).filter((_, index) => {
    if (
      sections[index].type === 'techs' &&
      size((sections[index] as ComponentSectionsSectionTechs).techs) === 0
    ) {
      return false
    }

    return true
  })

  return (
    // Dynamic + ProjectsSlider + Contacts
    [...dynamicThemes, hasProjects ? 'dark' : null, 'light']
      .filter(Boolean)
      // На светлой теме остаётся базовым цветом
      .map((i) => (i === 'light' ? '' : i)) as Array<'' | 'dark'>
  )
}

export type AltPageMainProps = {
  seo: ApiSeo
  path: string
  heading: string
  sub_heading?: string
  sections: DynamicSectionsDataType[]
  projects?: Array<{ project: ProjectBaseFragment }>
  navs?: AltPageLayoutNavs
}

const AltPageMain = (props: AltPageMainProps) => {
  const { seo, path, heading, sub_heading, navs, sections, projects } = props

  const hasProjects = size(projects) > 0

  return (
    <AltPageLayout
      seo={seo}
      path={path}
      title={heading}
      subTitle={sub_heading}
      navs={navs}
      firstSectionHasLabel={isFirstSectionHasLabel(sections)}
    >
      <HeaderThemeOnScrollChanger themes={getThemes(sections, hasProjects)} />
      <DynamicSections sections={sections} />
      {hasProjects ? <ProjectsSlider projects={projects!} /> : <Divider />}
      <FormSection />
    </AltPageLayout>
  )
}

export default AltPageMain
